export default class TableSearchbox extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.abortController = new AbortController();

    let input = this.querySelector('input');

    if (!this.querySelector('input')) {
      input = document.createElement('input');
      input.tabIndex = 0;
      input.placeholder = window.searchInTable;

      this.append(input);
    }

    input.addEventListener(
      'input',
      (e) => {
        this.tableFilter(e.currentTarget);
      },
      { signal: this.abortController.signal }
    );
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  tableFilter(input) {
    const filter = input.value.toUpperCase();
    const table = input.parentNode.nextElementSibling;
    const tbody = table.getElementsByTagName('tbody')[0];
    const tr = tbody.getElementsByTagName('tr');

    // Loop through all table rows, then through all row cells,
    // and hide the rows where none of the cells match the filter
    for (let i = 0; i < tr.length; i += 1) {
      if (!(tr[i].classList.contains('subhead1') || tr[i].classList.contains('subhead2'))) {
        tr[i].style.display = 'none';
        const td = tr[i].getElementsByTagName('td');

        for (let j = 0; j < td.length; j += 1) {
          if (td[j]) {
            const txtValue = td[j].textContent || td[j].innerText;

            if (txtValue.toUpperCase().indexOf(filter) > -1) {
              tr[i].style.display = '';
            }
          }
        }
      }
    }
  }
}

// Load table-searchbox if not already that exists
if (!customElements.get('table-searchbox')) {
  customElements.define('table-searchbox', TableSearchbox);
}

const tables = document.querySelectorAll('.table-wrapper.with-searchbox');

tables.forEach((table) => {
  const tableSearchBox = document.createElement('table-searchbox');

  table.before(tableSearchBox);
});
